interface FloatingButtonProps {
  icon: string;
  href: string;
  alt: string;
  external?: boolean;
}

export default function FloatingButton({
  icon,
  href,
  alt,
  external = true,
}: FloatingButtonProps) {
  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      aria-label={alt}
      className="
      floating-button
        flex
        items-center
        justify-center

        w-14
        h-14

        rounded-full

        bg-[#D8EEF0]

        shadow-lg

        transition-all
        duration-300

        hover:scale-110
        hover:bg-white
      ">
      <img
        src={icon}
        alt={alt}
        className="
          w-6
          h-6
          object-contain
        "
      />
    </a>
  );
}
